// External Libraries
import React from "react";

// Services
import ReconciliationService from "../../../../services/ReconciliationService";

// Common Components
import WComponent from "../../../common/WComponent";

import Button from "../../../common/button/Button";
import DateSelector from "../../../common/date_selector/DateSelector";
import Loader from "../../../common/loader/Loader";

// import ReconSummary from "./ReconciliationSummary";
// import ReconTable from "./ReconciliationTable";

// Styling
import "./hst-reconciliation-tool.css";

class HstReconciliationTool extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			// Input State
			endDate: new Date(),

			// Data State
			reconciliationData: [],
			filteredReconciliationData: [],
			currentYearSummary: [],

			// UI State
			loading: false,
			isReconciliationComplete: false
		};
	}

	onReconcileClicked = async e => {
		let { clientId } = this.props;
		let { endDate } = this.state;

		e.preventDefault();

		await this.update({
			loading: true
		});

		await ReconciliationService.downloadGSTSummaries({ clientId, endDate });
		await ReconciliationService.downloadGSTSummariesQuickMethod({ clientId, endDate });

		await this.update({
			loading: false
		});
	};

	onendDateChange = async endDate => {
		await this.update({ endDate });
	};

	render() {
		let { endDate, loading } = this.state;
		let { onReconcileClicked, onendDateChange } = this;

		return (
			<>
				<div className="container">
					<div className="container-header-title">
						<h1 className="container-header-title__name">HST Reconciliation Tool</h1>
					</div>

					<div className="hst-recon-tool__body">
						<DateSelector title="Year End" selectedDate={endDate ? new Date(endDate) : undefined} onDateSelect={onendDateChange} />

						<Button text="Reconcile" onClick={onReconcileClicked} />
					</div>

					{loading && (
						<div className="container-loader">
							<Loader />
						</div>
					)}
				</div>
			</>
		);
	}
}

export default HstReconciliationTool;
